<!-- 返却ボタン -->
<!-- Organisms(Dialog)を呼び出しているので単体テスト不可。一旦stortbookなし -->
<template>
  <li>
    <a @click="openDialogBookRestoreAlert"> このチケットを返却する </a>

    <!-- 返却前の注意ダイアログ -->
    <DialogBookRestoreAlert ref="DialogBookRestoreAlert" :bookId="bookId" />
  </li>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import DialogBookRestoreAlert from "@/views/Components/Organisms/MyTickets/Dialog/DialogBookRestoreAlert";

export default {
  name: "BFaceRestoreButton",
  components: {
    DialogBookRestoreAlert: DialogBookRestoreAlert,
  },
  props: {
    bookId: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const DialogBookRestoreAlert = ref(null);

    const openDialogBookRestoreAlert = () => {
      DialogBookRestoreAlert.value.openDialog();
    };

    return {
      DialogBookRestoreAlert,
      openDialogBookRestoreAlert,
    };
  },
};
</script>
